import moment from 'moment'

export default (timestamp) => timestamp && moment(timestamp, 'X').format('DD/MM/YYYY HH:mm')



// WEBPACK FOOTER //
// ./src/helpers/toLocaleDate.js